import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('bounty', {
  cherry: 'lasso',
  lemon: 'spurs',
  orange: 'holster',
  bell: 'jail_bell',
  star: 'sheriff_star_wild',
  seven: 'jail_cell',
  gem: 'citrine',
  scatter: 'handcuffs_scatter',
  money: 'bounty_bag',
});

/** Bounty — GENERATED by scaffoldSlot from
 *  content/slots/bounty.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const BOUNTY_THEME: Theme = {
  id: 'bounty',
  name: 'Bounty',
  palette: {
    accent: 0xb0833a,
    secondary: 0xd0aa6a,
    warm: 0xf2d27a,
    frameFill: 0x271c10,
    bgGradientTop: 0x46331d,
    bgGradientBottom: 0x17100a,
    dimOverlay: 0x0b0805,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Lasso', glyph: '🤠', tint: 0xc9a878, weight: 5, textureAlias: 'bounty:cherry',
        winVideoAlias: 'bounty:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Spurs', glyph: '✨', tint: 0xc0c0c0, weight: 5, textureAlias: 'bounty:lemon',
        winVideoAlias: 'bounty:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Holster', glyph: '🔫', tint: 0x8a5a3a, weight: 4, textureAlias: 'bounty:orange',
        winVideoAlias: 'bounty:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Jail Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'bounty:bell',
        winVideoAlias: 'bounty:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Sheriff\'s Star', glyph: '⭐', tint: 0xf0c84e, weight: 2, textureAlias: 'bounty:star',
        winVideoAlias: 'bounty:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Bounty', glyph: '🔒', tint: 0x8a8a8a, weight: 2, textureAlias: 'bounty:seven',
        winVideoAlias: 'bounty:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Citrine', glyph: '💎', tint: 0xe0a83a, weight: 2.5, textureAlias: 'bounty:gem',
        winVideoAlias: 'bounty:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Handcuffs', glyph: '⛓️', tint: 0xb0b0b0, weight: 0.5, textureAlias: 'bounty:scatter',
        winVideoAlias: 'bounty:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Bounty Bag', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'bounty:money',
        winVideoAlias: 'bounty:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x271c10, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xb0833a, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xd0aa6a, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xb0833a, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x271c10, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xd0aa6a, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xb0833a, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'bounty:bg', path: 'environment/bounty.png' },
      columnBackground: { alias: 'bounty:column_bg', path: 'reel/bounty_column_bg.png' },
      border: { alias: 'bounty:border', path: 'brand/border_frontier.png' },
    },
  },
};
